module.exports = __webpack_public_path__ + "img/20190910161242360截图20190910141740658.d35e649f.jpg";